import Vue from 'vue';
import VueHeadroom from 'vue-headroom';

Vue.use(VueHeadroom);
